// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from 'firebase/functions'; // Add this import

// // Determine which environment to use (default to production)
// Determine which environment to use
const nodeEnv = process.env.NODE_ENV;
const appEnv = process.env.REACT_APP_ENVIRONMENT;
const apiUrl = process.env.REACT_APP_API_URL;

// Better environment detection with Docker support
let currentEnv = "PRODUCTION";
if (nodeEnv === 'development' || apiUrl?.includes('localhost')) {
  currentEnv = "LOCAL";
} else if (appEnv === 'staging') {
  currentEnv = "STAGING";
}

console.log("Current environment:", currentEnv);
console.log("NODE_ENV:", nodeEnv);
console.log("REACT_APP_API_URL:", apiUrl);

// Your production Firebase configuration
const prodConfig = {
  apiKey: "AIzaSyAiq-6cDbL-iFajBcvmpPwmh_n0LlMqJO0",
  authDomain: "pickstarai.com",
  projectId: "just-rhythm-445002-s8-e92d0",
  storageBucket: "just-rhythm-445002-s8-e92d0.firebasestorage.app",
  messagingSenderId: "2002617503",
  appId: "1:2002617503:web:eb70913508c06d8f280eaa",
  measurementId: "G-303VPKTXSQ"
};

// Your staging Firebase configuration 
const stagingConfig = {
  apiKey: "AIzaSyD2uXgFdPPhbdWxFJp9vN0wuLkzpi_aERY",
  authDomain: "just-rhythm-staging.firebaseapp.com",
  projectId: "just-rhythm-staging",
  storageBucket: "just-rhythm-staging.firebasestorage.app",
  messagingSenderId: "232653925249",
  appId: "1:232653925249:web:b15b150874bd6b92401680",
  measurementId: "G-S44XG23QNY"
};

// Choose the right config based on environment
const firebaseConfig = appEnv === 'staging' ? stagingConfig : prodConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const functions = getFunctions(app, 'us-central1'); // Initialize functions with explicit region

// Initialize Firestore - declare the variable first
let db;

// Then assign it without custom database ID
try {
  db = getFirestore(app);
  console.log("Firestore initialized successfully");
} catch (error) {
  console.error("Error initializing Firestore:", error);
}

// Export what you need
export { app, auth, db, analytics, functions };


// Previous 4-28-25
// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAiq-6cDbL-iFajBcvmpPwmh_n0LlMqJO0",
//   // authDomain: "just-rhythm-445002-s8-e92d0.firebaseapp.com",
//   authDomain: "pickstarai.com",
//   projectId: "just-rhythm-445002-s8-e92d0",
//   storageBucket: "just-rhythm-445002-s8-e92d0.firebasestorage.app",
//   messagingSenderId: "2002617503",
//   appId: "1:2002617503:web:eb70913508c06d8f280eaa",
//   measurementId: "G-303VPKTXSQ"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);
// const auth = getAuth(app); // Initialize Firebase Authentication
// const analytics = getAnalytics(app); // Optional: Initialize Analytics if used
// const db = getFirestore(app); // Initialize Firestore

// // Export what you need
// export { app, auth, db, analytics };